import { useQuery } from "@apollo/client";
import { FC, useEffect, useState } from "react";
import { meGQL } from "@onmo/graphql/graphql";

interface IHelpShift {
  onClose: () => void;
}

export const HelpShift: FC<IHelpShift> = (props) => {
  const { onClose } = props;
  const { data: dataMe } = useQuery(meGQL);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) return;
    if (!dataMe) {
      window.Helpshift("updateHelpshiftConfig");
      window.Helpshift("open");
      return;
    }
    window.helpshiftConfig.language =
      dataMe?.me.language === "telefonica_es" ? "es" : dataMe?.me.language;
    window.helpshiftConfig.userId = dataMe?.me.id;
    window.helpshiftConfig.userEmail = dataMe?.me.email;
    window.helpshiftConfig.userName = dataMe?.me.username;
    window.Helpshift("updateHelpshiftConfig");
    window.Helpshift("open");
  }, [dataMe, isOpen]);

  useEffect(() => {
    const widgetToggleEventHandler = (data: { visible: boolean }) => {
      if (!data.visible) {
        onClose();
      }
      setIsOpen(data.visible);
    };
    window.Helpshift(
      "addEventListener",
      "widgetToggle" as any,
      widgetToggleEventHandler,
    );

    return () => {
      window.Helpshift(
        "removeEventListener",
        "widgetToggle" as any,
        widgetToggleEventHandler,
      );
    };
  }, [onClose]);

  return null;
};
